module.exports = __webpack_public_path__ + "img/translate.a046cfe6.svg";